// src/components/ui/TeamsList.tsx
import { Card } from "./card";
import { Button } from "./button";
import { Avatar, AvatarImage, AvatarFallback } from "./avatar";
import { Team } from "../../types/Team";

interface TeamsListProps {
  list: Team[];
  userType: string;
  onSelect?: (team: Team) => void;
  onDelete?: (team: Team) => void;
}

export function TeamsList({
  list,
  userType,
  onSelect,
  onDelete,
}: TeamsListProps) {
  if (!list || list.length === 0) {
    return (
      <p className="text-center text-gray-500 py-6 text-sm">
        No teams found.
      </p>
    );
  }

  return (
    <div className="space-y-3 mt-4">
      {list.map((item) => {
        const teamId = Number(item.team_id || (item as any).id);

        return (
          <Card
            key={teamId}
            className="p-4 hover:shadow-md transition-shadow cursor-pointer"
            onClick={() =>
              onSelect?.({
                ...item,
                team_id: teamId,
              })
            }
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <Avatar className="h-20 w-20 rounded-lg overflow-hidden">
                  <AvatarImage
                    src={
                      item.profile_image ||
                      item.cover_image ||
                      "/placeholder-avatar.jpg"
                    }
                  />
                  <AvatarFallback>IMG</AvatarFallback>
                </Avatar>

                <div>
                  <h3 className="font-semibold text-lg">{item.name}</h3>
                  <p className="text-muted-foreground text-sm">
                    {userType === "coach" ? "My Team" : "Team Member"}
                  </p>
                </div>
              </div>

              {userType === "coach" && (
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete?.({ ...item, team_id: teamId });
                  }}
                >
                  Delete
                </Button>
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
